import { Injectable } from '@angular/core';
import { HttpService } from '../shared/services/http.service';
import { tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class PermissionService {
  constructor(private httpService: HttpService) {}

  getFuncionalities() {
    return this.httpService.getFuncionalities().pipe(
      tap((data) => {
        localStorage.setItem('Permissions', JSON.stringify(data.Data));
      })
    );
  }
}